







































import { computed, defineComponent, ref } from '@vue/composition-api';
import { NotificationDataCheckinJobIcon } from '../icons';

export default defineComponent({
    name: 'DataCheckinJobDigest',
    components: { NotificationDataCheckinJobIcon },
    props: {
        notification: {
            type: Object,
            required: true,
        },
        referenceId: {
            type: String,
            required: true,
        },
    },
    setup(props) {
        const isHovered = ref(false);

        const getPayload = computed(() => {
            const payload = {
                name: 'data-checkin-jobs',
                params: {
                    id: props.referenceId,
                    status: props.notification.eventType,
                    type: props.notification.payload.referenceType,
                },
                query: {
                    pipeline: props.referenceId,
                },
            };
            return payload;
        });

        return {
            isHovered,
            getPayload,
        };
    },
});
